import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as VolumeActions from './volume.actions';
import { Deserialize } from 'cerialize';
import { Volume } from '../../models/volume';
import { ApiService } from '../../services/api.service';
import { ColorTools } from '../../tools/color.tools';
import { Store } from '@ngrx/store';
import { TranslocoService } from '@jsverse/transloco';
import { VolumeSummary } from '../../models/site';
import { Comment } from '../../models/comment';



@Injectable()
export class VolumeEffects {

  loadVolumes$ = createEffect(() => {
    return this.actions$.pipe(ofType(VolumeActions.loadVolumes),
      concatMap(({organizationId, siteId, comparedBatchId, referenceBatchId, threshold, step}) =>
      this.api.volumes$(organizationId, siteId, comparedBatchId,referenceBatchId, threshold).pipe(
        map(volumes => volumes.map((volume: any) => {
          const obj: Volume = Deserialize(volume, Volume);
          obj.name = this.translocoService.translate('volume') + " " + obj.id.slice(0,4).toUpperCase();
          return obj;
        })),
        map(volumes => ColorTools.setColorsForVolumes(volumes, step, this.store)),
        map(volumes => VolumeActions.loadVolumesSuccess({ volumes })),
        catchError(error => of(VolumeActions.loadVolumesFailure({ error }))))
    ));
  });

  loadVolumeSummary$ = createEffect(() => {
    return this.actions$.pipe(ofType(VolumeActions.loadVolumeSummary),
      concatMap(({organizationId, siteId, comparedBatchId, referenceBatchId}) =>
        this.api.volumesSummary$(organizationId, siteId, comparedBatchId, referenceBatchId).pipe(
          map(summary => Deserialize(summary, VolumeSummary)),
          map(summary => VolumeActions.loadVolumeSummarySuccess({ summary })),
          catchError(error => of(VolumeActions.loadVolumeSummaryFailure({ error }))))
      ));
  });

  loadVolumeComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VolumeActions.loadVolumeComments),
      concatMap(({ organizationId, siteId, batchId, detectionId }) =>
        this.api.volumeComments$(organizationId, siteId, batchId, detectionId).pipe(
          map(comments => comments.map((comment: any) => Deserialize(comment, Comment))),
          map(comments => VolumeActions.loadVolumeCommentsSuccess({ comments })),
          catchError(error => of(VolumeActions.loadVolumeCommentsFailure({ error })))
        )
      )
    )
  );

  addVolumeComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VolumeActions.addVolumeComment),
      concatMap(({ organizationId, siteId, batchId, detectionId, payload }) =>
        this.api.addVolumeComment$(organizationId, siteId, batchId, detectionId, payload).pipe(
          map(comment => Deserialize(comment, Comment)),
          map(comment => VolumeActions.addVolumeCommentSuccess({ comment })),
          catchError(error => of(VolumeActions.addVolumeCommentFailure({ error })))
        )
      )
    )
  );

  generateVolumesDXF$ = createEffect(() => {
    return this.actions$.pipe(ofType(VolumeActions.generateVolumesDXF),
      concatMap(({organizationId, siteId, ids, batchId}) =>
        this.api.generateVolumesDXF$(organizationId, siteId, ids, batchId).pipe(
          map(email => VolumeActions.generateVolumesDXFSuccess({ email })),
          catchError(error => of(VolumeActions.generateVolumesDXFFailure({ error }))))
      ));
  });

  constructor(private store: Store,
              private actions$: Actions,
              private api: ApiService,
              private translocoService: TranslocoService) {}

}
